<template>
  <v-layout>
    <v-main :class="containerState">
      <v-container id="main-container" class="pb-0" :fluid="true">
        <AppBar />

        <v-card class="d-flex flex-column fill-height" flat>
          <v-row no-gutters class="fill-height d-flex flex-nowrap">
            <v-col class="pa-0 sidebar-col-left">
              <AppSidebarEntity
                :entities="entities"
                @clickElement="setEditEntity"
              />
            </v-col>

            <v-col class="pa-0 flex-grow-1">
              <ConstructionAssociation
                ref="constructionAssociation"
                :entity="editEntity"
                :isOwner="hasPermission"
                @dataSourceAssociation="setDataSourceAssociation"
                @resetFields="resetDataSourceAssociation"
                @openDialogJsonProperty="openDialogJsonProperty"
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn color="secondary" variant="outlined" @click="abortModel">
              {{ $t("labels.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              class="bg-secondary"
              color="white"
              @click="routeTo('/editor/definition')"
            >
              {{ $t("labels.back") }}
            </v-btn>
            <v-btn
              variant="outlined"
              class="bg-secondary"
              color="white"
              :disabled="disabledSave"
              @click="saveModel"
            >
              {{ $t("labels.save") }}
            </v-btn>
            <v-btn
              variant="outlined"
              class="bg-secondary"
              color="white"
              @click="continueModel"
            >
              {{ $t("labels.continue") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
    <!--Dialog Json Property-->
    <DialogJsonProperty
      v-model="dialogJsonProperty"
      :jsonData="jsonData"
      :initJsonPath="initJsonPath"
      @confirm="insertJsonPath"
    />
    <!--Snackbar-->
    <v-snackbar v-model="snackbar" top color="green" timeout="5000">
      {{ snackbarText }}
      <template v-slot:actions="{ attrs }">
        <v-btn
          color="white"
          variant="text"
          v-bind="attrs"
          @click="snackbar = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-layout>
</template>

<script>
import AppBar from "./components/AppBar.vue";
import AppSidebarEntity from "./components/AppSidebarEntity.vue";
import ConstructionAssociation from "./components/ConstructionAssociation.vue";
import DialogJsonProperty from "./components/DialogJsonProperty.vue";
import version from "../version";
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import AppMixin from "@/mixins/AppMixin.js";
import permissions from "@/mixins/permissions.js";

export default {
  name: "DigitalTwinsData",
  components: {
    AppBar,
    AppSidebarEntity,
    ConstructionAssociation,
    DialogJsonProperty,
  },
  mixins: [utils, events, AppMixin, permissions],
  props: [
    "digitalTwinDataDefinitionConfig",
    "digitalTwinCommonConfig",
    "realm",
  ],
  data() {
    return {
      appVersion: version,
      containerState: "expanded",
      modelDT: JSON.parse(sessionStorage.getItem("digital-twin-model")),
      snackbar: false,
      snackbarText: "",
      editEntity: undefined,
      isChangedModel: false,
      dialogJsonProperty: false,
      jsonData: undefined,
      initJsonPath: undefined,
    };
  },
  created() {
    if (!this?.modelDT) {
      this.abortModel();
      return;
    }
  },
  mounted() {
    document.addEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });
  },
  beforeUnmount() {
    document.removeEventListener(
      "language-localstorage-changed",
      this.languageLocalstorageChanged,
    );
  },
  computed: {
    entities() {
      return this.modelDT?.modelGraph?.nodes || [];
    },
    disabledSave() {
      return !this.hasPermission || !this.isChangedModel;
    },
  },
  watch: {
    "modelDT.modelGraph.nodes": {
      handler() {
        this.isChangedModel = true;
      },
      deep: true,
    },
  },
  methods: {
    setEditEntity(el) {
      this.editEntity = el;
    },
    languageLocalstorageChanged(event) {
      this.setLocale(event.detail.storage);
    },
    insertJsonPath(jsonPath) {
      this.$refs.constructionAssociation?.restApiForm?.setJsonPath(jsonPath);
    },
  },
};
</script>

<style scoped>
main.expanded {
  margin-left: 56px;
}
main.expanded header#upp-bar {
  margin-left: 56px;
  width: calc(100% - 56px) !important;
}
main.reduced {
  margin-left: 256px;
}
main.reduced header#upp-bar {
  margin-left: 256px;
  width: calc(100% - 256px) !important;
}

#main-container {
  height: calc(100vh - 104px);
  overflow-y: auto;
  background-color: white;
}

.sidebar-col-left {
  width: 300px;
  max-width: 300px;
}
</style>
